module.exports = __webpack_public_path__ + "static/media/bp_measure_step2.92378a60.gif";